import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'

import ProtectedRoute from './components/protected.route'
import ProtectedRouteAdm from './components/protected.route.adm'

import Layout from './components/Layout'

import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import DashboardFinanceiro from './pages/DashboardFinanceiro'

import Usuarios from './pages/Usuarios'


import Emissao from './pages/Emissao'


import CadastroConvite from './pages/CadastroConvite'
import Corretor from './pages/Corretor'
import Produtor from './pages/Produtor'
import Tomador from './pages/Tomador'
import Favorecido from './pages/Favorecido'
import Modalidades from './pages/Modalidades'
import Avalista from './pages/Avalista'

import AdmUsuarios from './pages/AdmUsuarios'
import AdmClientes from './pages/AdmClientes'
import Documento from './pages/Documento'

import ResgataSenha from './pages/ResgataSenha'

import RelatorioEmissao from './pages/RelatorioEmissao'
import RelatorioFinanceiro from './pages/RelatorioFinanceiro'
import RelatorioGarantia from './pages/RelatorioGarantia'
import RelatorioTomador from './pages/RelatorioTomador'

const Rotas = () => {

    return (

        <QueryClientProvider client={new QueryClient}>

            <BrowserRouter>

                <Routes>

                    <Route path='/' element={<Login />} />  
                    <Route path='/03!ZXqW771/:cliente_id/:chaveLink' element={<CadastroConvite />} />

                    <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                            
                            <Route path='/Dashboard' element={<Dashboard />} />
                            <Route path='/Dashboard/Financeiro' element={<DashboardFinanceiro />} />
                            
                            <Route path='/Produtor' element={<Produtor />} />
                            <Route path='/Corretor' element={<Corretor/>} />
                            <Route path='/Tomador' element={<Tomador />} />
                            <Route path='/Favorecido' element={<Favorecido />} />                        
                            <Route path='/Emissao' element={<Emissao />} />
                            <Route path='/Modalidades' element={<Modalidades />} />

                            <Route path='/Usuarios' element={<Usuarios />} />

                            <Route path='/Adm/Usuarios' element={<AdmUsuarios />} />
                            
                            <Route path='/Avalista' element={<Avalista />} />
                            
                            <Route path='/Documento' element={<Documento />} />                            

                            <Route path='/Relatorio/Emissao' element={<RelatorioEmissao />} />
                            <Route path='/Relatorio/Financeiro' element={<RelatorioFinanceiro />} />
                            <Route path='/Relatorio/Garantias' element={<RelatorioGarantia />} />
                            <Route path='/Relatorio/Tomadores' element={<RelatorioTomador />} />


                            <Route element={<ProtectedRouteAdm />}>

                                <Route path='/Adm/Clientes' element={<AdmClientes />} />
                                
                            </Route>
                            
                            
                    </Route>

                    <Route path='/0!zX125/:usuario_id/:token' element={<ResgataSenha />} />
                    


                </Routes>

            
            </BrowserRouter>

        </QueryClientProvider>

    )


}

export default Rotas